import { render, staticRenderFns } from "./ReportSetting.vue?vue&type=template&id=59c7a132&"
import script from "./ReportSetting.vue?vue&type=script&lang=js&"
export * from "./ReportSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c7a132')) {
      api.createRecord('59c7a132', component.options)
    } else {
      api.reload('59c7a132', component.options)
    }
    module.hot.accept("./ReportSetting.vue?vue&type=template&id=59c7a132&", function () {
      api.rerender('59c7a132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/PillReport/ReportSetting.vue"
export default component.exports